import { withRouter } from "react-router-dom";
import MainVideo from "../../video/cooking-video.mp4";
import MobileVideo from "../../video/cooking-video-mobile.mp4";
import VideoIcon from "../../images/video-icon.svg";

const Video = () => {
  const handleClick = () => {
    window.open('https://forms.gle/Ryrz2AkFLMsyVjLA9', '_blank');
  };
  return (
    <div className="video">
      <video
        className="video-desktop"
        width="100%"
        height="100%"
        muted
        loop
        autoPlay
        playsInline
      >
        <source src={MainVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <video
        className="video-mobile"
        width="100%"
        height="100%"
        muted
        loop
        autoPlay
        playsInline
      >
        <source src={MobileVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="text-container">
        <h1>
          <span>serving</span> soon
        </h1>
        <h2>sign up for beta game</h2>
        <p>
          Join the excitement! Sign up today & become a part of the upcoming
          version, marking only the start of your extraordinary journey.
        </p>
        <button onClick={handleClick}>SIGNUP</button>
      </div>
      <img className="video-image" src={VideoIcon} alt="icon" />
    </div>
  );
};

export default withRouter(Video);
